// Vehicle creation module - handles plate search and auto-fill functionality

import { getMasksValidator } from "../shared/masks-validator.js";
import { getVehiclePlanController } from "./plan-controller.js";

$(document).ready(function () {
    // Initialize masks validator
    const masksValidator = getMasksValidator();
    masksValidator.setupPlateMasks();

    // Initialize vehicle creation functionality
    initVehicleCreation();

    // Initialize client selection functionality
    initClientSelection();
});

function initVehicleCreation() {
    // Verificar se estamos na página de edição de veículos
    const isVehicleEditPage =
        window.location.pathname.includes("/veiculos/") &&
        window.location.pathname.includes("/edit");

    // Initialize plan controller (sempre executar)
    const planController = getVehiclePlanController();

    // Apenas bloquear funções que limpam campos na página de edição
    if (isVehicleEditPage) {
        return;
    }

    // Setup plate search functionality (apenas em páginas de criação)
    setupPlateSearch();

    // Setup vehicle type buttons (apenas em páginas de criação)
    setupVehicleTypeButtons();

    // Setup brand and model selection (apenas em páginas de criação)
    setupBrandModelSelection();
}

function setupPlateSearch() {
    const plateInput = $("#inputPlate");
    let searchTimeout;

    plateInput.on("input", function () {
        const plate = $(this)
            .val()
            .replace(/[^A-Z0-9]/g, ""); // Remove non-alphanumeric

        // Clear previous timeout
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        // Only search if plate has minimum length (7 characters for both formats)
        if (plate.length >= 7) {
            // Add debounce to avoid excessive API calls
            searchTimeout = setTimeout(() => {
                // Add loading indicator
                plateInput.addClass("loading");
                searchVehicleByPlate(plate);
            }, 500); // Wait 500ms after user stops typing
        } else {
            // Clear fields if plate is too short
            clearVehicleFields();
        }
    });
}

function searchVehicleByPlate(plate) {
    $.ajax({
        url: "/veiculos/buscar-dados",
        method: "POST",
        data: {
            placa: plate,
            _token: $('meta[name="csrf-token"]').attr("content"),
        },
        success: function (response) {
            $("#inputPlate").removeClass("loading");

            if (response.success && response.data) {
                let vehicleData;

                // Parse data if it's a string
                if (typeof response.data === "string") {
                    try {
                        vehicleData = JSON.parse(response.data);
                    } catch (e) {
                        return;
                    }
                } else {
                    vehicleData = response.data;
                }

                // Fill form with vehicle data
                fillVehicleData(vehicleData);

                // Removido: showMessage de sucesso desnecessário
                // showMessage("Dados do veículo encontrados e preenchidos automaticamente!", "success");
                // Esta mensagem era redundante pois o preenchimento automático já indica sucesso
            } else {
                // Clear fields if no data found
                clearVehicleFields();
                // Removido: showMessage("Placa não encontrada na base de dados.", "info");
                // Esta mensagem era desnecessária pois não adiciona valor ao usuário
            }
        },
        error: function (xhr, status, error) {
            $("#inputPlate").removeClass("loading");
            showMessage(
                "Erro ao buscar dados do veículo. Tente novamente.",
                "error"
            );
        },
    });
}

function fillVehicleData(data) {
    const findField = (baseId, idSuffix = "") => {
        return $("#".concat(baseId).concat(idSuffix));
    };

    const inputBrand = findField("inputBrand");
    const inputModel = findField("inputModel");
    const inputYearOfManufacture = findField("inputYearOfManufacture");
    const inputYearModel = findField("inputYearModel");
    const inputTypeOfFuel = findField("inputTypeOfFuel");
    const inputChassis = findField("inputChassis");
    const inputCarColor = findField("inputCarColor");
    const inputRenavam = findField("inputRenavam");
    const inputEngineNumber = findField("inputEngineNumber");
    const referenceModel = findField("referenceModel");

    inputBrand.prop("disabled", false);
    inputModel.prop("disabled", false);

    const marcasProblemas = {
        LR: "Land Rover",
        "M.BENZ": "Mercedes-Benz",
        KIA: "Kia Motors",
        TOYOTA: "Toyota",
        T: "Hyundai",
    };

    try {
        const processedData =
            typeof data === "string" ? JSON.parse(data) : data;

        let marca;
        if (processedData?.fipe?.dados?.length > 0) {
            marca = processedData.fipe.dados[0].codigo_marca;
        } else if (processedData.MARCA) {
            let marcaNome = processedData.MARCA;
            marcaNome = marcasProblemas[marcaNome] || marcaNome;
            const option = inputBrand.find("option").filter(function () {
                return $(this).text().toUpperCase() === marcaNome.toUpperCase();
            });
            marca = option.length ? option.val() : undefined;
        } else if (processedData.marca) {
            let marcaNome = processedData.marca;
            marcaNome = marcasProblemas[marcaNome] || marcaNome;
            const option = inputBrand.find("option").filter(function () {
                return $(this).text().toUpperCase() === marcaNome.toUpperCase();
            });
            marca = option.length ? option.val() : undefined;
        }

        if (
            !marca ||
            inputBrand.find(`option[value='${marca}']`).length === 0
        ) {
            showMessage(
                "Marca não encontrada: verifique se o tipo de veículo está correto.",
                "error"
            );
            return;
        }

        // Extrair modelos da API externa para filtros
        const modelos = (processedData.listamodelo || []).map(function (m) {
            return m.toUpperCase();
        });

        // Preencher campos básicos
        inputBrand.val(marca || "");
        inputModel.val(
            processedData.MODELO && processedData.MODELO !== "null"
                ? processedData.MODELO
                : ""
        );
        inputYearOfManufacture.val(
            processedData.ano && processedData.ano !== "null"
                ? processedData.ano
                : ""
        );
        inputYearModel.val(
            processedData.anoModelo && processedData.anoModelo !== "null"
                ? processedData.anoModelo
                : ""
        );
        inputTypeOfFuel.val(
            processedData.extra?.combustivel &&
                processedData.extra?.combustivel !== "null"
                ? processedData.extra.combustivel
                : ""
        );
        inputChassis.val(
            processedData.extra?.chassi &&
                processedData.extra?.chassi !== "null"
                ? processedData.extra.chassi
                : ""
        );
        inputCarColor.val(
            processedData.cor && processedData.cor !== "null"
                ? processedData.cor
                : ""
        );
        inputRenavam.val(
            processedData.extra?.renavam &&
                processedData.extra?.renavam !== "null"
                ? processedData.extra.renavam
                : ""
        );
        inputEngineNumber.val(
            processedData.extra?.motor && processedData.extra?.motor !== "null"
                ? processedData.extra.motor
                : ""
        );

        console.log(processedData);
        // Exibir referência do modelo
        if (processedData.marcaModelo && processedData.marcaModelo !== "null") {
            // Armazenar a referência globalmente para uso posterior
            currentMarcaModelo = processedData.marcaModelo;
            referenceModel.text(`(${processedData.marcaModelo})`).show();
        } else if (
            processedData.marcamodelo &&
            processedData.marcamodelo !== "null"
        ) {
            // Armazenar a referência globalmente para uso posterior
            currentMarcaModelo = processedData.marcamodelo;
            referenceModel.text(`(${processedData.marcamodelo})`).show();
        } else {
            currentMarcaModelo = null;
            referenceModel.hide();
        }

        // Carregar modelos e aplicar filtros como no exemplo anterior
        const vehicleType = getSelectedVehicleType();

        // Verificar se marca é válida antes de fazer a requisição
        if (!marca || marca === "") {
            return;
        }

        fetch(`/veiculos/obter-modelos/${marca}?tipo=${vehicleType}`)
            .then(function (res) {
                return res.json();
            })
            .then(function (modelData) {
                inputModel
                    .empty()
                    .append(
                        '<option value="" selected disabled>Selecione o modelo</option>'
                    );

                // Carrega TODOS os modelos primeiro
                modelData.forEach(function (model) {
                    const displayText = model.refFipe
                        ? `${model.nomeModelo} (${model.refFipe})`
                        : model.nomeModelo;
                    const option = $("<option></option>")
                        .val(model.codModelo)
                        .text(displayText)
                        .attr("data-reference", model.refFipe || "");
                    inputModel.append(option);
                });

                // Aplica filtros baseado nos modelos da API externa
                var modelosValidos = modelos;
                var cont = 0;

                inputModel.find("option").each(function () {
                    if ($(this).val() === "") return; // Pula a opção "Selecione o modelo"

                    var optionText = $(this).text().toUpperCase();
                    var matchCount = modelosValidos.reduce(function (
                        count,
                        modelo
                    ) {
                        if (
                            optionText.includes(modelo) ||
                            optionText.includes("IMP/" + modelo)
                        ) {
                            return count + 1;
                        }
                        return count;
                    },
                        0);

                    if (matchCount >= 2) {
                        cont++;
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });

                // Se nenhum modelo foi encontrado com os filtros, mostra TODOS
                if (cont === 0) {
                    inputModel.find("option").show();
                }

                // Atualiza a referência do modelo selecionado
                updateModelReference();
            })
            .catch(function (error) { });
    } catch (error) { }
}

function handleBrandSelection(brandName, modelName) {
    // First, try to find the brand in the current options
    const brandSelect = $("#inputBrand");
    let brandOption = brandSelect
        .find(`option:contains("${brandName}")`)
        .first();

    if (brandOption.length) {
        // Brand found, select it
        brandSelect.val(brandOption.val()).trigger("change");

        // Wait for models to load, then select model or find similar
        setTimeout(() => {
            if (modelName) {
                findSimilarModel(modelName);
            }
        }, 500);
    } else {
        // Brand not found, show message
        showMessage(`Marca "${brandName}" não encontrada na lista.`, "warning");
    }
}

function findSimilarModel(targetModelName) {
    const modelSelect = $("#inputModel");
    const options = modelSelect.find("option");
    let bestMatch = null;
    let bestScore = 0;

    // Se não há modelo alvo, não faz busca
    if (!targetModelName || targetModelName.trim() === "") {
        return null;
    }

    options.each(function () {
        const option = $(this);
        const optionValue = option.val();

        // Pula a opção vazia
        if (!optionValue) return;

        const modelName = option.text();
        const reference = option.attr("data-reference") || "";

        // Calcula similaridade baseada na referência (peso maior) e nome do modelo
        let score = 0;

        if (reference && reference.trim() !== "") {
            const refSimilarity = calculateSimilarity(
                targetModelName.toUpperCase(),
                reference.toUpperCase()
            );
            score += refSimilarity * 0.7; // Peso maior para referência
        }

        const nameSimilarity = calculateSimilarity(
            targetModelName.toUpperCase(),
            modelName.toUpperCase()
        );
        score += nameSimilarity * 0.3; // Peso menor para nome

        if (score > bestScore && score > 0.5) {
            // Threshold mínimo de 50%
            bestScore = score;
            bestMatch = option;
        }
    });

    return bestMatch;
}

function calculateSimilarity(str1, str2) {
    // Simple similarity calculation using Levenshtein distance
    const longer = str1.length > str2.length ? str1 : str2;
    const shorter = str1.length > str2.length ? str2 : str1;

    if (longer.length === 0) return 1.0;

    const distance = levenshteinDistance(longer, shorter);
    return (longer.length - distance) / longer.length;
}

function levenshteinDistance(str1, str2) {
    const matrix = [];

    for (let i = 0; i <= str2.length; i++) {
        matrix[i] = [i];
    }

    for (let j = 0; j <= str1.length; j++) {
        matrix[0][j] = j;
    }

    for (let i = 1; i <= str2.length; i++) {
        for (let j = 1; j <= str1.length; j++) {
            if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
                matrix[i][j] = matrix[i - 1][j - 1];
            } else {
                matrix[i][j] = Math.min(
                    matrix[i - 1][j - 1] + 1,
                    matrix[i][j - 1] + 1,
                    matrix[i - 1][j] + 1
                );
            }
        }
    }

    return matrix[str2.length][str1.length];
}

function clearVehicleFields() {
    // Clear all vehicle data fields except plate
    const fieldsToKeep = ["#inputPlate"];
    const allFields = [
        "#inputBrand",
        "#inputModel",
        "#inputYearOfManufacture",
        "#inputYearModel",
        "#inputTypeOfFuel",
        "#inputChassis",
        "#inputCarColor",
        "#inputRenavam",
        "#inputEngineNumber",
        "#inputHP",
        "#inputMileage",
    ];

    allFields.forEach((field) => {
        if (!fieldsToKeep.includes(field)) {
            if ($(field).is("select")) {
                $(field).val("").trigger("change");
            } else {
                $(field).val("");
            }
        }
    });

    // Limpar também a referência do modelo apenas quando apropriado
    // Não limpar se estamos apenas mudando de marca/modelo
    const currentPlate = $("#inputPlate").val();
    if (!currentPlate || currentPlate.length < 7) {
        $("#referenceModel").text("").hide();
    }
}

function setupVehicleTypeButtons() {
    $(".vehicle-type-button").on("click", function () {
        const tipo = $(this).data("tipo");

        // Remove active class from all buttons
        $(".vehicle-type-button").removeClass("active");

        // Add active class to clicked button
        $(this).addClass("active");

        // Update hidden input
        $("#tipoVeiculo").val(tipo);

        // Load brands for selected vehicle type
        loadBrandsByType(tipo);

        // Clear model selection when vehicle type changes
        $("#inputModel")
            .empty()
            .append('<option value="">Selecione o modelo</option>');
    });

    // Load initial brands
    const initialType =
        $(".vehicle-type-button.active").data("tipo") || "carros";
    loadBrandsByType(initialType);
}

function loadBrandsByType(tipo) {
    const brandSelect = $("#inputBrand");

    fetch(`/veiculos/obter-marcas/${tipo}`)
        .then((response) => response.json())
        .then((data) => {
            brandSelect
                .empty()
                .append('<option value="">Selecione a marca</option>');

            data.forEach((brand) => {
                const option = document.createElement("option");
                option.value = brand.codMarca;
                option.textContent = brand.nomeMarca;
                brandSelect.append(option);
            });

            // Clear model selection when brands are loaded
            $("#inputModel")
                .empty()
                .append('<option value="">Selecione a marca primeiro</option>');
        })
        .catch((error) => { });
}

function setupBrandModelSelection() {
    $("#inputBrand").on("change", function () {
        const codMarca = $(this).val();
        const modelSelect = $("#inputModel");
        const vehicleType = getSelectedVehicleType();

        // Ocultar o span de referência quando a marca muda
        const referenceSpan = $("#referenceModel");
        referenceSpan.hide();

        // Limpar currentMarcaModelo da API quando marca muda manualmente
        currentMarcaModelo = null;

        if (codMarca && vehicleType) {
            // Adaptar chamada da API conforme o tipo de veículo
            const apiEndpoint = `/veiculos/obter-modelos/${codMarca}?tipo=${vehicleType}`;

            fetch(apiEndpoint)
                .then((response) => response.json())
                .then((data) => {
                    modelSelect
                        .empty()
                        .append('<option value="">Selecione o modelo</option>');

                    // Carrega TODOS os modelos da marca
                    data.forEach((model) => {
                        const option = document.createElement("option");
                        option.value = model.codModelo;
                        // Formato: "Modelo (Referência)"
                        const displayText = model.refFipe
                            ? `${model.nomeModelo} (${model.refFipe})`
                            : model.nomeModelo;
                        option.textContent = displayText;
                        option.setAttribute(
                            "data-reference",
                            model.refFipe || ""
                        );
                        modelSelect.append(option);
                    });

                    // Implementar sistema de filtro
                    setupModelFilter(modelSelect);

                    // Reconfigurar evento change após carregar modelos
                    setupModelChangeEvent();
                })
                .catch((error) => { });
        } else {
            const message = !vehicleType
                ? "Selecione o tipo de veículo primeiro"
                : "Selecione uma marca primeiro";
            modelSelect.empty().append(`<option value="">${message}</option>`);
        }
    });

    // Configurar evento inicial
    setupModelChangeEvent();
}

function setupModelChangeEvent() {
    // Remove eventos anteriores para evitar duplicação
    $("#inputModel").off("change.reference");

    // Adicionar evento para exibir referência quando modelo for selecionado
    $("#inputModel").on("change.reference", function () {
        updateModelReference();
    });
}

// Variável global para armazenar a referência do modelo da API
let currentMarcaModelo = null;

function updateModelReference() {
    const inputModel = $("#inputModel");
    const selectedOption = inputModel.find("option:selected");
    const referenceSpan = inputModel
        .closest(".col-md-6, .form-group, .row")
        .find("#referenceModel");

    // Verificar se temos marcaModelo da API (busca por placa)
    if (currentMarcaModelo) {
        referenceSpan.text(`(${currentMarcaModelo})`).show();
    } else {
        referenceSpan.hide();
    }
}

function getSelectedVehicleType() {
    const activeButton = $(".vehicle-type-button.active");
    if (activeButton.length) {
        return activeButton.data("tipo");
    }
    return null;
}

function setupModelFilter(modelSelect) {
    // Converter select em um campo com filtro
    const originalOptions = Array.from(modelSelect[0].options).slice(1); // Remove primeira opção

    modelSelect.on("focus", function () {
        // Criar input de filtro se não existir
        if (!$("#modelFilter").length) {
            const filterInput = $(`
                <input type="text" id="modelFilter" class="form-control"
                       placeholder="Digite para filtrar por modelo ou referência..."
                       style="margin-bottom: 5px;">
            `);

            modelSelect.before(filterInput);

            filterInput.on("input", function () {
                const filterText = $(this).val().toLowerCase();
                modelSelect
                    .empty()
                    .append('<option value="">Selecione o modelo</option>');

                // Filtrar por nome do modelo ou referência
                const filteredOptions = originalOptions.filter((option) => {
                    const optionText = option.textContent.toLowerCase();
                    const reference =
                        option.getAttribute("data-reference") || "";
                    const referenceText = reference.toLowerCase();

                    // Buscar tanto no nome do modelo quanto na referência
                    return (
                        optionText.includes(filterText) ||
                        referenceText.includes(filterText)
                    );
                });

                // Ordenar resultados: primeiro por referência, depois por nome
                filteredOptions.sort((a, b) => {
                    const aRef = (
                        a.getAttribute("data-reference") || ""
                    ).toLowerCase();
                    const bRef = (
                        b.getAttribute("data-reference") || ""
                    ).toLowerCase();
                    const aText = a.textContent.toLowerCase();
                    const bText = b.textContent.toLowerCase();

                    // Se o filtro corresponde à referência, priorizar
                    const aRefMatch = aRef.includes(filterText);
                    const bRefMatch = bRef.includes(filterText);

                    if (aRefMatch && !bRefMatch) return -1;
                    if (!aRefMatch && bRefMatch) return 1;

                    // Caso contrário, ordenar alfabeticamente
                    return aText.localeCompare(bText);
                });

                filteredOptions.forEach((option) => {
                    modelSelect.append(option.cloneNode(true));
                });

                // Reconfigurar evento após filtrar
                setupModelChangeEvent();
            });

            // Remover filtro quando perder o foco
            filterInput.on("blur", function () {
                setTimeout(() => {
                    if (!modelSelect.is(":focus")) {
                        $(this).remove();
                    }
                }, 200);
            });
        }
    });
}

/**
 * Exibe mensagem para o usuário usando Bootstrap alerts
 * @param {string} message - Mensagem a ser exibida
 * @param {string} type - Tipo da mensagem (success, error, info, warning)
 */
function showMessage(message, type = "info") {
    // Verificar se jQuery está disponível
    if (typeof $ === "undefined") {
        return;
    }

    // Mapear tipos para classes Bootstrap
    let alertClass;
    switch (type) {
        case "success":
            alertClass = "alert-success";
            break;
        case "error":
            alertClass = "alert-danger";
            break;
        case "warning":
            alertClass = "alert-warning";
            break;
        case "info":
        default:
            alertClass = "alert-info";
            break;
    }

    const alertHtml = `
        <div class="alert ${alertClass} alert-dismissible fade show" role="alert">
            ${message}
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
    `;

    // Tentar inserir no container específico, senão usar o container padrão dentro da main-content-page
    let container = $("#alert-container");
    if (container.length === 0) {
        container = $(".main-content-page");
        if (container.length === 0) {
            container = $("body");
        }
    }

    // Se estiver inserindo diretamente na main-content-page, adicionar margem
    if (container.hasClass("main-content-page")) {
        container.prepend(`<div class="mb-3">${alertHtml}</div>`);
    } else {
        container.html(alertHtml);
    }

    // Auto-remover após 5 segundos
    setTimeout(function () {
        $(".alert").fadeOut();
    }, 5000);
}

// Export functions for global access
export { initVehicleCreation, searchVehicleByPlate };

function initClientSelection() {
    // Setup client card display when client is selected
    setupClientCardDisplay();

    // Check for URL parameter idClient and handle pre-selection
    handleClientPreSelection();
}

function setupClientCardDisplay() {
    // Handler para exibir card quando cliente é selecionado
    $("#selectClient").on("change", function () {
        const clientId = $(this).val();

        if (clientId) {
            // Buscar dados do cliente e exibir card
            fetchClientDataAndDisplayCard(clientId);
        } else {
            // Ocultar card se nenhum cliente selecionado
            hideClientCard();
        }
    });
}

function handleClientPreSelection() {
    // Capturar parâmetro idClient da URL
    const urlParams = new URLSearchParams(window.location.search);
    const clientId = urlParams.get("idClient");

    if (clientId) {
        // Aguardar o carregamento dos clientes e então selecionar
        $(document).on("clientesCarregados", function () {
            const $selectClient = $("#selectClient");

            // Verificar se o cliente existe no select
            if ($selectClient.find(`option[value="${clientId}"]`).length > 0) {
                $selectClient.val(clientId).trigger("change");
            }
        });
    }
}

function fetchClientDataAndDisplayCard(clientId) {
    $.ajax({
        url: `/clientes/getClientById/${clientId}`,
        type: "POST",
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        success: function (response) {
            if (response.success && response.results) {
                displayClientCard(response.results);
            } else {
                hideClientCard();
            }
        },
        error: function (xhr, status, error) {
            hideClientCard();
        },
    });
}

function displayClientCard(clientData) {
    const $cardContainer = $(".card-result-client");
    const $clientSelected = $("#clientSelected");

    // Formatar telefone se existir (prioriza celular, depois fixo)
    let telefone = "Não informado";
    if (clientData.telefone_celular) {
        telefone = formatPhone(clientData.telefone_celular);
    } else if (clientData.telefone_fixo) {
        telefone = formatPhone(clientData.telefone_fixo);
    }

    // Determinar nome a ser exibido (PF usa nome, PJ usa razao_social)
    const nomeExibicao =
        clientData.tipo_cliente === "PF"
            ? clientData.nome || "Nome não informado"
            : clientData.razao_social || "Razão social não informada";

    // Montar HTML do card
    const cardHtml = `
        <input type="hidden" name="idCliente" value="${clientData.id}">
        <input type="hidden" name="oficinaVinculada" value="${clientData.oficina_vinculada}">
        <div>
            <span class="icon-box"><i class="sg sg-user"></i></span>
            <div>
                <span class="d-block">${nomeExibicao}</span>
            </div>
        </div>
        <hr>
        <div>
            <span class="icon-box"><i class="sg sg-phone"></i></span>
            <span>${telefone}</span>
        </div>
    `;

    // Inserir conteúdo e exibir card
    $clientSelected.html(cardHtml);
    $cardContainer.show();
}

function hideClientCard() {
    const $cardContainer = $(".card-result-client");
    const $clientSelected = $("#clientSelected");

    // Limpar conteúdo e ocultar card
    $clientSelected.empty();
    $cardContainer.hide();
}

function formatPhone(phone) {
    // Remove todos os caracteres não numéricos
    const cleaned = phone.replace(/\D/g, "");

    // Aplica formatação baseada no tamanho
    if (cleaned.length === 11) {
        // Celular: (XX) 9 XXXX-XXXX
        return cleaned.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3-$4");
    } else if (cleaned.length === 10) {
        // Fixo: (XX) XXXX-XXXX
        return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    } else {
        // Retorna o telefone original se não conseguir formatar
        return phone;
    }
}
